import { cva } from "class-variance-authority";

export const checkboxContainerCva = cva("checkbox-container flex flex-row items-center", {
  variants: {
    disabled: {
      true: "cursor-not-allowed opacity-50",
      false: null,
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export const checkboxLabelCva = cva("text-sm leading-4 cursor-pointer select-none", {
  variants: {
    position: {
      left: "mr-2.5",
      right: "ml-2.5",
    },
    variant: {
      light: "text-gray-800 dark:text-gray-200",
    },
    disabled: {
      true: "cursor-not-allowed",
      false: null,
    },
  },
  defaultVariants: {
    position: "left",
    variant: "light",
    disabled: false,
  },
});

export const checkboxWrapperCva = cva("checkbox-wrapper relative", {
  variants: {},
  defaultVariants: {},
});

export const checkboxInputCva = cva("checkbox-input sr-only", {
  variants: {},
  defaultVariants: {},
});

export const checkboxCustomCva = cva("checkbox-custom", {
  variants: {
    disabled: {
      true: "cursor-not-allowed",
      false: "cursor-pointer",
    },
  },
  defaultVariants: {
    disabled: false,
  },
});
